import Box from '@mui/material/Box'

const ConversationHistoryAdmin = () => {
    return (
        <Box
            sx={{
                height: '100%',
                maxHeight: 150,
                overflowY: 'auto',
                padding: 0
            }}
        />
    )
}

export default ConversationHistoryAdmin
